import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    '& table': {
      borderCollapse: 'collapse',
    },
    '& th, & td': {
      border: `1px solid ${theme.palette.divider}`,
    },
  },
  tableHeader: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.spanishGray,
  },
  tableCellText: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'normal',
    verticalAlign: 'top',
    overflow: 'visible',
  },
  textFieldFull: {
    width: '100%',
  },
}))

export default useStyles
